$(document).ready(function() {
	var lang = $('html').attr('lang');

	/**
	 * Gestion resize + scroll
	 */
	// Resize de la fenêtre
	/*resize_window();
	$(window).resize(function() {
		resize_window();
	});*/

	// Gestion du scroll
	handle_scroll();
	/*$(window).scroll(function() {
		handle_scroll();
	});*/
	$(window).scroll(debounce(handle_scroll, 10));

	// WOW
	new WOW().init();

	// Lazyload
	lazyload();

	// Formulaires
	if ($('.form_common').length > 0) {
		$('.form_common').each(function() {
			var form = $(this);
			form.find('input, select, textarea').each(function() {
				var field = $(this);
				field.on('focus', function() {
					field.addClass('validation');
				});
			});
		});
	}

	// Menu
	var isHeaderLight = $('.header').hasClass('header_light');
	$('#check_burger').on('change', function() {
		var isChecked = $(this).is(':checked');
		$('.barre_menu').css({'opacity' : 1});
		$('.barre_menu').toggleClass('active');
		$('.header').toggleClass('menu_open');
		if (isHeaderLight) {
			$('.header').toggleClass('header_light header_dark');
		}
	});
});

function resize_window() {

}

function handle_scroll() {
	var scroll_top = $(window).scrollTop();

	if (scroll_top > 0) {
		$('.header').addClass('fixed');
	} else {
		$('.header').removeClass('fixed');
	}
}
